<template>
  <div class="close_box">
    <img class="close_icon" src="@/assets/mylogin/gantanhao-2.png" alt="" />
    <p class="close_title">您的商品推广功能已被关闭，暂时无法使用</p>
    <div class="close_tips_box">
      <p class="tips_title">请注意以下事项</p>
      <p class="tips_content">· 暂不能推广商品，已推广的商品不再产生商品佣金</p>
      <p class="tips_content">· 已推广成单的收益不受影响，将正常结算</p>
    </div>
    <p class="close_reason" v-show="reason">关闭原因：{{ reason }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reason: "",
    };
  },
  created() {
    this.getReason();
  },
  methods: {
    async getReason() {
      let res = await this.$apis.extendServe.hasExtendLimits();
      if (res.resultCode === "200") {
        this.reason = res.data.closeReason;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.close_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  background-color: #fff;
  min-height: calc(100vh - 44px);
  //   text-align: center;
  .close_icon {
    width: 40px;
    height: 40px;
  }
  .close_title {
    margin-top: 18px;
    font-size: 14px;
    color: #333333;
    line-height: 20px;
  }
  .close_tips_box {
    margin-top: 25px;
    padding: 12px 15px;
    width: 100%;
    background: #f1f4fe;
    border-radius: 5px;
    text-align: left;
    font-size: 13px;
    color: #666666;
    .tips_title {
      margin-bottom: 9px;
      line-height: 19px;
    }
    .tips_content {
      line-height: 24px;
    }
  }
  .close_reason {
    margin-top: 12px;
    font-size: 13px;
    color: #999999;
    line-height: 19px;
    text-align: left;
  }
}
</style>